<template>
    <div :style="{'direction': $vs.rtl ? 'rtl' : 'ltr'}">
      <feather-icon 
        icon="Edit3Icon" 
        svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" 
        @click="editRecord"
        v-if="$store.state.AppActiveUser.userInfo.roles[0].permissions.map(permission => permission.name).includes('update_role')"
      />
      <feather-icon 
        icon="Trash2Icon" 
        svgClasses="h-5 w-5 hover:text-danger cursor-pointer" 
        @click="confirmDeleteRecord"
        v-if="$store.state.AppActiveUser.userInfo.roles[0].permissions.map(permission => permission.name).includes('delete_role')" 
      />
    </div>
</template>

<script>
export default {
  name: 'CellRendererActions',

  computed: {
    encryptedID () {
      return this.$secure.encrypt(this.params.data.id)
    }
  },

  methods: {
    editRecord () {
      this.$router.push({ name: 'role-edit', params: {id: this.encryptedID}})
    },
    
    confirmDeleteRecord () {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm Delete',
        text: `You are about to delete "${this.params.data.name}"`,
        accept: this.deleteRecord,
        acceptText: 'Delete'
      })
    },
    deleteRecord () {
      this.$store.dispatch("roleManagement/destroyData", this.params.data.id)
                  .then(() => { this.showDeleteSuccess() })
                  .catch(err => { 
                    this.$vs.notify({
                      color: 'danger',
                      title: 'Failed to delete',
                      text: `The selected role can't be deleted`
                    })
                  })
    },
    showDeleteSuccess () {
      this.$vs.notify({
        color: 'success',
        title: 'User Deleted',
        text: 'The selected user was successfully deleted'
      })
    }
  }
}
</script>
